module.exports.ERROR_CODE = Object.freeze({
  BAD: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  ERROR_INTERNAL: 500,
  ERROR_VERSION: 900,
});

module.exports.BILL_ITEM_TYPE = Object.freeze({
  PRODUCT: 1, // sản phẩm
  PRODUCT_BONUS: 2, // sản phẩm tặng kèm
  PRODUCT_PROMTION: 3, // sản phẩm bán kèm
  RETURN_WARRANTY: 4, // sản phẩm trả bảo hành
});

module.exports.CONTACT_TYPE = Object.freeze({
  Customer: 1,
  Provider: 2,
  Installment: 3,
  Employee: 4,
  Credit: 5,
  Other: 20,
});

module.exports.TRANSACTION_TYPE = Object.freeze({
  CashIn: 1, // Phiếu thu
  CashOut: 2, // Phiếu chi
  BankIn: 3, // Báo có (nộp tiền)
  BankOut: 4, // Báo nợ (Rút tiền)
  MerchandiseReturn: 5, // Phiếu bán hàng
  Sale: 6, // Phiếu bán hàng
  StockImport: 8, // Phiếu nhập
  GoodsIssue: 9, // Phiếu xuất hàng
});

module.exports.TRANSACTION_DOC_TYPE = Object.freeze({
  BILL: 1,
  ORDER: 2,
});

module.exports.TRANSACTION_TYPE_NAME = Object.freeze({
  [this.TRANSACTION_TYPE.CashIn]: 'Phiếu thu', // Phiếu thu
  [this.TRANSACTION_TYPE.CashOut]: 'Phiếu chi', // Phiếu chi
  [this.TRANSACTION_TYPE.BankIn]: 'Báo có (nộp tiền)', // Báo có (nộp tiền)
  [this.TRANSACTION_TYPE.BankOut]: 'Báo nợ (Rút tiền)', // Báo nợ (Rút tiền)
  [this.TRANSACTION_TYPE.MerchandiseReturn]: 'Phiếu bán hàng', // Phiếu bán hàng
  [this.TRANSACTION_TYPE.Sale]: 'Phiếu bán hàng', // Phiếu bán hàng
  [this.TRANSACTION_TYPE.StockImport]: 'Phiếu nhập', // Phiếu nhập
  [this.TRANSACTION_TYPE.GoodsIssue]: 'Phiếu xuất hàng', // Phiếu xuất hàng
});

module.exports.STOCK_SLIP_TYPE = Object.freeze({
  IMPORT_PROVIDER: 'IMPORT_STOCK', // nhập kho NCC
  EXPORT_PROVIDER: 'EXPORT_STOCK', // xuất kho tra hang NCC
  EXPORT_WARRANTY_TO_PROVIDER: 'EXPORT_WARRANTY_TO_PROVIDER', // xuất kho bảo hành NCC
  EXPORT_STOCK_TO_SALE: 'EXPORT_STOCK_TO_SALE', // xuất kho bán lẻ
  EXPORT_STOCK_TO_SALE_WHOLSE: 'EXPORT_STOCK_TO_SALE_WHOLSE', // xuat kho ban buon
  REQUIRE_EXPORT_STOCK: 'REQUIRE_EXPORT_STOCK',
  REQUIRE_IMPORT_STOCK: 'REQUIRE_IMPORT_STOCK',
  TRANSFER_STOCK: 'TRANSFER_STOCK',
  // TRANSFER_STOCK: 3, // chuyen kho
  // REQUIRE_IMPORT_STOCK: 4, // yeu cau nhap chuyen kho
  // REQUIRE_EXPORT_STOCK: 5, // yeu cau xuat chuyen kho
  // // EXPORT_STOCK_TO_SALE: 6, // xuat kho ban le
  // EXPORT_STOCK_TO_SALE_WHOLSE: 7, // xuat kho ban buon
  // IMPORT_STOCK_FROM_BILL: 8, // nhap kho tu phieu tra hang
  // IMPORT_STOCK_FROM_ORDER: 9, // nhap kho tu don chuyen hoan
  // EXPORT_TO_SHIPPING: 10, // xuat kho giao hang
  // IMPORT_FROM_TRADE_IN: 11, // nhap kho tu phiếu thu cũ
  // TRANSFER_TO_NHANH: 12, // chuyen kho sang he thong cu
  // REQUIRE_EXPORT_STOCK_TO_NHANH: 13, // phiếu yêu cầu xuất chuyển kho sang hệ thống cũ
  // EXPORT_TRANSFER_TO_NHANH: 14, // xuat chuyen kho sang he thong cu
  // IMPORT_WARRANTY: 15, // nhập kho bảo hành
  // EXPORT_WARRANTY: 16, // xuất kho bảo hành
  // IMPORT_HOLDING: 17, // nhập giữ hàng
  // EXPORT_HOLDING: 18, // xuất trả giữ hàng
  // TRANSFER_WARRANTY_STOCK: 19, // chuyển kho bảo hành
  // REQUIRE_EXPORT_WARRANTY_STOCK: 20, // yeu cau xuat chuyen kho bao hanh
  // IMPORT_STOCK_FROM_WARRANTY_BILL: 22, // nhap kho tu phieu bao hanh
  // IMPORT_WARRANTY_FROM_BILL: 23, // nhập kho bảo hành từ hóa đơn bảo hành
  // EXPORT_WARRANTY_FROM_BILL: 24, // xuất kho bảo hành từ hóa đơn bảo hành
  // EXPORT_STOCK_BY_WARRANTY_BILL: 25, // xuất kho bởi trả khác mã từ hóa đơn bảo hành
  // // EXPORT_WARRANTY_TO_PROVIDER: 26, // Xuất kho bảo hành trả nhà cung cấp
  // UPDATE_EXPORT_WARRANTY_TO_PROVIDER: 27, // cập nhật phiếu xuất kho bảo hành trả ncc
  // DELETE_EXPORT_WARRANTY_TO_PROVIDER: 28, // xóa phiếu xuất kho bảo hành trả ncc
  // CREATE_WARRANTY_COMPLETION_SLIP: 29, // tạo phiếu hoàn tất bảo hành
  // DELETE_WARRANTY_COMPLETION_SLIP: 30, // xoá phiếu hoàn tất bảo hành
  // IMPORT_STOCK_BY_WARRANTY_COMPLETION: 31, // nhập kho bởi phiếu hoàn tất bảo hành
  // EXPORT_STOCK_BY_WARRANTY_COMPLETION: 32, // xuất kho bởi phiếu hoàn tất bảo hành
  // EXPORT_WARRANTY_STOCK_BY_DELETE_WARRANTY_BILL: 33, // xuất kho bảo hành bởi bởi xoá hoá đơn bảo hành
  // IMPORT_STOCK_BY_DELETE_WARRANTY_BILL: 34, // nhập kho bởi bởi xoá hoá đơn bảo hành
  // IMPORT_STOCK_BY_DELETE_STORE_WARRANTY_BILL: 35, // nhập kho bởi bởi xoá hoá đơn bảo hành (lỗi cửa hàng)
  // EXPORT_STOCK_BY_CREATE_STORE_WARRANTY_BILL: 36, // xuất kho bởi tạo hoá đơn bảo hành (lỗi cửa hàng)
  // EXPORT_STOCK_BY_INVENTORY_CHECK: 37, // xuất kho bảo hành từ phiếu kiểm tồn
  // IMPORT_STOCK_BY_INVENTORY_CHECK: 38, // nhập kho từ phiếu kiểm kê sản phẩm
  // EXPORT_LENDING: 39, // phiếu cho mượn máy
  // IMPORT_STOCK_LENDING: 40, // nhập kho cho mượn máy
  // IMPORT_WARRANTY_FROM_PROVIDER: 41, // nhập kho bảo hành nhà cung cấp (tồn thực tế)
  // EXPORT_STOCK_LOSS: 44, // Xuất kho thất thoát
  // EXPORT_STOCK_CLEARANCE: 45, // Xuất kho thanh lý
  // IMPORT_STOCK_LOSS: 46, // nhập kho thất thoát
});

module.exports.PRODUCT_HISTORY_ACTION = Object.freeze({
  IMPORT_STOCK: 1,
  EXPORT_STOCK: 2,
  EXPORT_STOCK_TO_SALE: 3,
  EXPORT_STOCK_TO_SALE_WHOLSE: 4,
  EXPORT_WARRANTY_TO_PROVIDER: 5,
  TRANSFER_STOCK: 6,
  UPDATE_IMPORT_STOCK_SLIP: 7,
  UPDATE_EXPORT_STOCK_SLIP: 8,
  DELETE_IMPORT_STOCK_SLIP: 9,
  DELETE_EXPORT_STOCK_SLIP: 10,
  DELETE_TRANSFER_STOCK_SLIP: 11,
  DELETE_BILL: 12,
  UPDATE_BILL: 13,
  CANCEL_STOCK_SLIP_TRANSFER: 14, // hủy phiếu chuyển kho
  UNKNOWN: 15,
});

module.exports.PRODUCT_HISTORY_ACTION_MAPPING = Object.freeze({
  1: 'Nhập kho',
  2: 'Xuất kho',
  3: 'Xuất kho bán lẻ',
  4: 'Xuất kho bán buôn',
  5: 'Xuất kho bảo hành NCC',
  6: 'Chuyển kho',
  7: 'Cập nhật phiếu nhập kho',
  8: 'Cập nhật phiếu xuất kho',
  9: 'Xóa phiếu nhập kho',
  10: 'Xóa phiếu xuất kho',
  11: 'Xóa phiếu chuyển kho',
  12: 'Xóa hóa đơn',
  13: 'Cập nhật hóa đơn',
  14: 'Hủy phiếu chuyển kho',
  15: 'Không xác định',
});

module.exports.AMOUNT_TYPE = Object.freeze({
  MONEY: 1, // tiền mặt
  PERCENT: 2, // theo %
});

module.exports.STATUS_COMMON = Object.freeze({
  ACTIVE: 1, // Hoạt động
  INACTIVE: -1, // Tạm ngưng
});

module.exports.AMOUNT_TYPE_VEHICLE = Object.freeze({
  AMOUNT: 'AMOUNT',
  PERCENT: 'PERCENT',
});

module.exports.PRODUCT_TYPE = Object.freeze({
  PRODUCT: 1, // sản phẩm
  PRODUCT_IMEI: 2, // sản phẩm IMEI
  PRODUCT_COMBO: 3, // sản phẩm combo
  PRODUCT_SERVICE: 4, // sản phẩm dịch vụ
});

module.exports.PRODUCT_TYPE_ENUM = Object.freeze({
  CHASSIS_ENGINE: 'CHASSIS_ENGINE',
  SERIES: 'SERIES',
  DEFAULT: 'DEFAULT',
  SERVICE: 'SERVICE',
  INDEPENDENT: 'INDEPENDENT',
});

module.exports.PRODUCT_STATUS = Object.freeze({
  NEW: 1, // mới
  SELLING: 2, // đang bán
  STOP_SELLING: 3, // ngừng bán
  OUT_OF_STOCK: 4, // hết hàng
});

module.exports.STOCK_SLIP_STATUS = Object.freeze({
  NEW: 1, // mới
  APPROVED: 2, // đã duyệt
  CONFIRMED: 3, // đã xác nhận
  CANCELD: 4,
});

module.exports.TYPE_ORDER = Object.freeze({
  SHOP: 1, // Mua tại quầy
  PREORDER: 2, // Đặt trước
  // SHIPPING: 3, // Chuyển hàng
  // EX_SHIPPING: 4, // Hãng vận chuyển
  // WEBSITE: 5, // Website
});

module.exports.ORDER_ITEM_PRODUCT_TYPE = Object.freeze({
  MAIN: 1,
  GIFT: 2,
  ATTACH: 3,
});

module.exports.ORDER_HISTORY_ACTION_ENUM = Object.freeze({
  CREATE: 1,
  UPDATE: 2,
  DELETE: 3,
});

module.exports.ORDER_STATUS = Object.freeze({
  NEW: 1 /* Chờ xác nhận */,
  CONFIRMED: 2 /* Đã xác nhận */,
  DELIVERY: 3 /* Đang giao hàng */,
  SUCCESS: 4 /* Thành công */,
  UN_SUCCESS: 5 /* Không thành công */,
  REFUNDED: 6 /* Đã chuyển hoàn */,
  CR_CANCEL: 7 /* CR huỷ */,
});
module.exports.PRODUCT_STOCK_CHECK_STATUS = Object.freeze({
  NEW: 1, // Mới
  DONE: 2, // Hoàn Thành
  STOCK_DIFF: 3, // Phiếu lệch kho cần kế toán xử lý
  STOCK_DEBT: 4, //  truy thu lệch kho
  COMFIRM: 5, // xác nhận kiểm kê
});

module.exports.DEBT_STOCK_STATUS = Object.freeze({
  NEW: 1, // Mới
  DONE: 2, // Hoàn thành
});

module.exports.CRITERIA_FILTER_BILL = Object.freeze({
  HAVE_DISCOUNT: 1, // Có tiền chiết khấu
  NO_DISCOUNT: 2, //Không có tiền chiết khấu
  HAVE_TRANSFER: 3, // Có tiền chuyển khoản
  HAVE_CREDIT: 4, // Có thanh toán quẹt thẻ
  HAVE_INSTALLMENT: 5, // Có thanh toán trả góp
  USE_POINT: 6, // Có dùng tiền tích điểm
  HAVE_DEBT: 7, // Có công nợ
  STILL_OWE: 8, // Còn công nợ
  OUT_OF_DEBT: 9, // Hết công nợ
  HAVE_CASH: 10, // Có tiền mặt
  FROM_ORDER: 11, // Hóa đơn từ đơn hàng
  HAVE_GIFT: 12, //Có quà tặng
  HAVE_DEPOSIT: 13, // có cọc từ đơn hàng
  UNDERPAYMENT: 14, // còn thiếu tiền
  UNPAID: 15, // chưa thanh toán
  NO_CODESHIP: 16, // chưa gắn code ship
  USE_COUPON: 17,
});

module.exports.PURCHASE_ORDER_STATUS = Object.freeze({
  NEW: 1, // Mới
  PURCHASE: 2, // Ngành hàng
  ACCOUNTANT: 3, // Kế toán
  PO_HEAD_CANCEL: 4, // trưởng ngành hàng hủy phiếu
  ACCOUNTANT_CANCEL: 5, // kế toán hủy phiếu
  READY: 6, // sẵn sàng để duyệt
  CANCELED: 7, // hủy yêu cầu
  SHOP_APPROVAL: 8, // AM duyệt đơn từ cửa hàng
});

module.exports.PURCHASE_ORDER_SOURCE = Object.freeze({
  STORE: 1, // nguồn cửa hàng
  PURCHASE: 2, // nguồn ngành hàngß
});

module.exports.PURCHASE_ORDER_APPROVE_MODE = Object.freeze({
  PURCHASE: 'purchase',
  ACCOUNTANT: 'accountant',
});

module.exports.PURCHASE_ORDER_TYPE = Object.freeze({
  IMPORT: 1,
  CONSIGNMENT: 2,
});

module.exports.LOAN_APPLICATION_STATUS = Object.freeze({
  INIT: 1,
  SUBMITED: 2,
  APPROVED: 3,
  REJECTED: 4,
  DISBURSED: 5,
  OP_PROCESSING: 6,
});

module.exports.UPLOAD_ENTITY = Object.freeze({
  BILLS: 'bills',
  BILLS_INVOICE: 'bills-invoices',
  PO: 'purchase-orders',
  STOCK_SLIP: 'stock-slips',
  TRANSACTIONS: 'transactions',
  ORDERS: 'orders',
});

module.exports.CUSTOMER_TYPE = Object.freeze({
  RETAIL_CUSTOMER: 1, // khách lẻ
  WHOLESALE_CUSTOMER: 2, // khách buôn
  AGENCY: 3, // đại lý
  VIP: 4, // vip
  KOL: 5, // kol
});

module.exports.PRODUCT_SEARCH_TYPE = Object.freeze({
  PRODUCT_NAME: 1, // tìm theo tên, mã, mã vạch
  IMEI_CODE: 2, // tìm theo mã IMEI
  FLEXIBLE_COMBO: 3,
  CHASSIS_ENGINE: 4,
  SERIAL: 5,
});

module.exports.FILE_UPLOAD_STATUS = Object.freeze({
  NEW: 1, // Mới
  EXIST: 2, // Tồn tại
});

module.exports.FILE_UPLOAD_MODE = Object.freeze({
  INITIAL: 0, // Mới
  SAVING: 1, // Tồn tại
  SUCCESS: 2, // Tồn tại
  FAILED: 3, // Tồn tại
});

module.exports.JOB_TITLE = Object.freeze({
  GD: 1, // Giám đốc
  RSM: 2, // Quản lý vùng
  ASM: 3, // Quản lý khu vực
  QL: 4, // Quản lý cửa hàng
  TL: 5, // Trợ lý cửa hàng
  KTBH: 6, // Kế toán bán hàng
  TVBH: 7, // Tư vấn bán hàng
  KTPM: 8, // Hỗ trợ kỹ thuật
  TDKH: 9, // Tiếp đón khách hàng
  KTPC: 10, // Kỹ thuật phần cứng
  GDNHPK: 11, // Giám đốc ngành hàng phụ kiện
  NVNHPK: 12, // NV phụ trách ngành hàng PK
  ADMIN_NHPK: 13, // Admin ngành hàng phụ kiện
  CDPK: 14, // nhân viên chuyên doanh phụ kiện
  QL_CSKH: 15, // quản lý CR
  CSKH: 16, // nhân viên CR
  CTV_CSKH: 17, // cộng tác viên CR
  ADMIN_GDNHPK: 18, // Admin giám đốc ngành hàng phụ kiện
  KTNB: 19, // Kế toán nội bộ
  QL_DP: 20, // Trưởng bộ phận điều phối
  MKT: 21, // Nhân viên marketing
  QL_MKT: 22, // Trưởng marketing
  DP: 23, // Điều phối
  QL_KTNB: 24, // Trưởng kế toán nội bộ
  NV_QA: 25, // Nhân viên kiểm định chất lượng (Kiểm soát/QA)
  GDNH: 35, // Giám đốc ngành hàng
  HV_QL: 40, // Học việc quản lý
  HV_TL: 41, // Học việc trợ lý
  ADMIN_MKT: 57, // Admin marketing
  TRADE_MKT: 94, // Trade marketing
  TRADE_MKT_MANAGER: 106, // Trade marketing manager
  CR_LEADER_LQD: 88, // Team leader CR LQĐ
  CR_LEADER_TQK: 89, // Team leader CR TQK
});

module.exports.JOB_TITLE_ORDER = Object.freeze({
  CR: [this.JOB_TITLE.QL_CSKH, this.JOB_TITLE.CSKH, this.JOB_TITLE.CTV_CSKH],
  SHOP: [
    this.JOB_TITLE.ASM,
    this.JOB_TITLE.QL,
    this.JOB_TITLE.TL,
    this.JOB_TITLE.KTBH,
    this.JOB_TITLE.TVBH,
    this.JOB_TITLE.KTPM,
    this.JOB_TITLE.TDKH,
    this.JOB_TITLE.KTPC,
  ],
  DP: [this.JOB_TITLE.DP, this.JOB_TITLE.QL_DP],
});

module.exports.PARTNER_PAYMENT = Object.freeze({
  SUCCESS: 1, // Thành công
  FAILED: 2, // Thất bại
  AGREE_DEPOSIT: 3, // Đồng ý cọc
  DEPOSIT: 4, // Đã đặt cọc
});

module.exports.HISTORY_TYPE = Object.freeze({
  ORDER: 1, // đơn hàng
  BILL: 2, // bán hàng
  PRODUCT: 3, // sản phẩm
  PRODUCT_IMEI: 4, // sản phẩm IMEI
  PRE_ORDER: 5, // đơn đặt trước
  STOCK_SLIP: 6, // phiếu kho
});

module.exports.HISTORY_ACTION_TYPE = Object.freeze({
  UPDATE: 1, // cập nhật
  DELETE: 2, // xóa
  CREATE: 3, // tạo mới
});

module.exports.MODAL_TYPE_UPSERT_ORDER = Object.freeze({
  GIFT: 'gift',
  ATTACH: 'attach',
  PRODUCT_IMEI: 'note',
  CHANGE_GIFT: 'change-gift',
  CHANGE_MAIN: 'change-main',
});

module.exports.PAYMENT_TYPE = Object.freeze({
  CASH: 'CASH',
  TRANSFER: 'TRANSFER',
  CREDIT: 'CREDIT',
  INSTALLMENT: 'INSTALLMENT',
  CREDIT_FEE: 'CREDIT_FEE',
  REFUND: 'REFUND',
  INSTALLMENT_FEE: 'INSTALLMENT_FEE',
});

module.exports.PAYMENT_REF_TYPE = Object.freeze({
  BILL: 'BILL',
  BILL_REFUND: 'BILL_REFUND',
  BILL_INFO: 'BILL_INFO',
  ORDER: 'ORDER',
  STOCK_DEBT: 'STOCK_DEBT',
  STOCK_SLIP: 'STOCK_SLIP',
});

module.exports.ACCOUNTANT_TYPE = Object.freeze({
  DEFAULT: 'DEFAULT', // Tài khoản mặc định
  CASH: 'CASH', // Tài khoản tiền mặt
  TRANSFER: 'TRANSFER', // Tài khoản ngân hàng
  CREDIT: 'CREDIT', // Tài khoản quẹt thẻ
  INSTALLMENT: 'INSTALLMENT', // Tài khoản trả góp
});

module.exports.BILL_TYPE = Object.freeze({
  RETAIL: 'RETAIL',
  WHOLESALE: 'WHOLESALE',
  SHIPPING: 'SHIPPING',
  // RETAIL_INVOICE: 'RETAI', // hóa đơn bán lẻ
  // WHOLESALE_INVOICE: 'RETAI', // hóa đơn bán buôn
  // REFUND_INVOICE: 'RETAI', // trả hàng
  // SHIPPING: 'RETAI', // hóa đơn giao hàng
  // IMPORT_STOCK_FROM_TRANSFER: 'RETAI', // enum này dùng cho phiếu nhập kho từ phiếu chuyển kho
  // WARRANTY: 'RETAI', // hóa đơn bảo hành
  // CONVERT: 'RETAI', // hóa đơn chuyển đổi
});
module.exports.WARRANTY_BILL_STATUS = Object.freeze({
  NEW: 1, // mới
  PROCESSING: 2, // đang xử lý
  DONE: 3, // đã trả bảo hành
  TRANSFER_STOCK: 4, // đang chuyển kho BH
  //One Touch Point
  SENT_REVENUE: 10, // Đã chuyển doanh thu
  VERIFY_REVENUE: 11, // Đã xác nhận doanh thu
});
module.exports.WARRANTY_REASON_STATUS = Object.freeze({
  ACTIVE: 0, // hoạt động
  INACTIVE: 1, // không hoạt động
});
module.exports.WARRANTY_REASON_GROUP_STATUS = Object.freeze({
  ACTIVE: 0, // hoạt động
  INACTIVE: 1, // không hoạt động
});
module.exports.PO_RELATION_TYPE = Object.freeze({
  INDEPENDENT: 1,
  PARENT: 2,
  CHILD: 3,
});
module.exports.BILL_VAT_TYPE = Object.freeze({
  PERSONAL: 1,
  COMPANY: 2,
});

module.exports.VAT_INVOICE_STATUS = Object.freeze({
  NEW: 1,
  PROCESSING: 2,
  PUBLIC: 3,
  CUSTOMER_SENT: 4,
  REFUND: 5,
});

module.exports.OPERATOR_TYPE = Object.freeze({
  NONE: 1, // không xác định (--)
  LT: 2, // nhỏ hơn (<)
  GT: 3, // lớn hơn (>)
  LTE: 4, // nhỏ hơn hoặc bằng (<=)
  GTE: 5, // lớn hơn hoặc bằng (>=)
});

module.exports.APPROVAL_STEP_STATUS = Object.freeze({
  NEW: 1,
  APPROVED: 2,
  CANCELED: 3,
  PAID: 4,
  PAY_FAILED: 5,
  COMPLETED: 6,
  ON_APPROVE: 7,
  CHECKED: 8,
});

module.exports.APPROVAL_TYPE_ENUM = Object.freeze({
  OVER_PAYMENT: 1, // thanh toán dư
  BUY_OLD: 2, // thu cũ
  REFUND: 3, // trả hàng
  TRADE_IN: 4, // thu cũ đổi mới
  VAT: 5, // xuất hóa đơn VAT
  DEPOSIT: 6, // hoàn cọc đơn hàng
});

module.exports.APPROVAL_PAYMENT_TYPE = Object.freeze({
  CASH: 1,
  TRANSFER: 2,
});

module.exports.VAT_INVOICE_PUSH = Object.freeze({
  UN_APPROVED: 1,
  APPROVED: 2,
  SUBMITED: 3,
});

module.exports.VAT_AMOUNT = Object.freeze({
  PERCENT_0: 0,
  PERCENT_8: 8,
  PERCENT_10: 10,
  PERCENT_KCT: -1,
});

module.exports.TRANSFER_STORE_FORM_STATUS = Object.freeze({
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3,
  APROVED_TRANSFER: 4,
});

module.exports.JOB_TITLE_EMLOYEE_STORE = Object.freeze([
  this.JOB_TITLE.KTBH,
  this.JOB_TITLE.TVBH,
  this.JOB_TITLE.KTPM,
  this.JOB_TITLE.TDKH,
  this.JOB_TITLE.KTPC,
]);

module.exports.JOB_TITLE_SHOW_BY_OWNER = Object.freeze([
  this.JOB_TITLE.QL,
  this.JOB_TITLE.TL,
]);

module.exports.JOB_TITLE_APPROVE = Object.freeze([
  this.JOB_TITLE.ASM,
  this.JOB_TITLE.RSM,
  this.JOB_TITLE.GD,
]);

module.exports.ENVIRONMENT = Object.freeze({
  BETA_FEATURE_STORE_ID: 88036,
});

// module.exports.STORE_TYPE = Object.freeze({
//   DDV: 1,
//   VDD: 2,
//   MBF: 3,
//   DP: 4,
// });
module.exports.STORE_TYPE = Object.freeze({
  VF: 'VF',
});

module.exports.VAT_INVOICE_PUSH = Object.freeze({
  UN_APPROVED: 1,
  APPROVED: 2,
  SUBMITED: 3,
});

module.exports.VAT_AMOUNT = Object.freeze({
  PERCENT_0: 0,
  PERCENT_8: 8,
  PERCENT_10: 10,
  PERCENT_KCT: -1,
});

module.exports.DELETE_TYPE = Object.freeze({
  AVAILABLE: 0,
  DELETED: 1,
});

module.exports.VAT_SYNC_STATUS = Object.freeze({
  NEW: 1,
  SENT_FAIL: 2,
  SENT_SUCCESS: 3,
  PUBLICH: 4,
  CANCELED: 5,
});

module.exports.PARTNER_API_STATUS = Object.freeze({
  ACTIVE: 1,
  INACTIVE: 2,
});

module.exports.PARTNER_API_DETAIL_TYPE = Object.freeze({
  PRODUCT: 1,
  STORE: 2,
  CATEGORY: 3,
});

module.exports.ACTION_TYPE = Object.freeze({
  CREATE: 1,
  UPDATE: 2,
});

module.exports.PAYMENT_STATUS = Object.freeze({
  SUCCESS: 1,
  FAILED: 2,
});

module.exports.ACCOUNTANT_STATUS = Object.freeze({
  ACTIVE: 1,
  INACTIVATE: 2,
});

module.exports.REFERENCE_TYPE = Object.freeze({
  BILL: 1,
  ORDER: 2,
});

module.exports.DELETE_TYPE = Object.freeze({
  AVAILABLE: 0,
  DELETED: 1,
});

module.exports.COUPON_STATUS = Object.freeze({
  ACTIVATE: 1,
  INACTIVATE: 0,
});

module.exports.VOUCHER_STATUS = Object.freeze({
  ACTIVATE: 1,
  INACTIVATE: 0,
});

module.exports.PAYROLL_TYPE = Object.freeze({
  STANDARD_WORKING_HOUR: 1, // Theo giờ công chuẩn
  STANDARD_NIGHT_WORKING_DAY: 2, // Theo ngày công chuẩn làm đêm
  STANDARD_NIGHT_WORKING_HOUR: 3, // Theo giờ công chuẩn làm ban đêm
  STANDARD_WORKING_HOUR_IMPORTED: 4, // Theo ngày công chuẩn import
  STANDARD_WORKING_DAY: 5, // Theo ngày công chuẩn
  EXEMPT_FROM_TIMEKEEPING: 6, // Theo miễn chấm công
  TARGET_REPORT: 7, // Theo báo cáo mục tiêu
});

module.exports.TRADE_IN_TYPE = Object.freeze({
  TRADE_IN: 1, // Khách thu cũ đổi mới
  BUYING_OLD_ITEMS: 2, // Khách thu cũ không đổi mới
  EXCHANGE_WARRANTY: 3, // Khách đổi bảo hành
});

module.exports.BILL_STATE = Object.freeze({
  DELETED: 'DELETED',
  NO_AMOUNT: 'NOAMOUNT',
});

module.exports.IMEI_STATUS = Object.freeze({
  NEW: 1, // Mới
  SALED: 2, // Đã bán
  TRANSFERING: 3, // Đang vận chuyển
  ERROR: 4, // Lỗi
  RETURN_TO_SUPPLIER: 5, // Đã trả NCC
  STOCK_TRANSFER: 6, // Đang chuyển kho
  EXPORT_WARRANTY: 7, // đã trả bảo hành
  ON_WARRANTY: 8, // đang bảo hành
  ON_HOLDING: 9, // đang giữ hàng
  ON_LENDING: 10, // đang cho mượn
  LOSS: 11, // thất thoát
});

module.exports.POSM_INPUT_TYPE = Object.freeze({
  TEXT: 1,
  IMAGE: 2,
  FILE: 3,
  DROPDOWN: 4,
});
module.exports.POSM_TYPE = Object.freeze({
  EXTERIOR: 1,
  INTERIOR: 0,
});

module.exports.POSM_GENERAL_LOCATIONS = Object.freeze({
  EXTERIOR_CATEGORIES: 'exteriorCategories',
  INTERIOR_CATEGORIES: 'interiorCategories',
});

module.exports.STOCK_HISTORY = Object.freeze({
  IMPORT_STOCK: 1, // nhap kho tu nha cung cap
  EXPORT_STOCK: 2, // xuat kho tra nha cung cap
  TRANSFER_STOCK: 3, // chuyen kho
  UPDATE_IMPORT_STOCK: 4, // cap nhat phieu nhap kho
  UPDATE_EXPORT_STOCK: 5, // cap nhat phieu xuat kho
  EXPORT_TO_TRANSFER: 6, // xuat chuyen kho
  IMPORT_FROM_TRANSFER: 7, // nhap chuyen kho
  EXPORT_TO_SALE_RETAIL: 8, // xuat kho ban le
  EXPORT_TO_SALE_WHOLE_SASE: 9, // xuat kho bán buon
  IMPORT_FROM_RETURN_BILL: 10, // nhap kho tu phieu tra hang
  IMPORT_FROM_REFUND_ORDER: 11, // nhập kho từ đơn chuyển hoàn
  EXPORT_TO_SHIPPING: 12, // xuất kho giao hàng
  INVENTORY_BALANCE: 13, // cân kho
  IMPORT_WARRANTY: 14, // nhập kho bảo hành
  UPDATE_IMPORT_WARRANTY: 15, // cập nhật nhập kho bảo hành
  EXPORT_WARRANTY: 16, // xuất kho bảo hành
  UPDATE_EXPORT_WARRANTY: 17, // cập nhật xuất kho bảo hành
  CHANGE_PRODUCT_IMEI: 18, // đổi sản phẩm IMEI
  REMOVE_FROM_BILL: 19, // xóa SP trong hóa đơn
  REMOVE_BILL: 20, // xóa hóa đơn
  REMOVE_RETURN_BILL: 21, // xóa hóa đơn trả hàng
  UPDATE_EXPORT_TO_SALE: 22, // cập nhật hóa đơn
  DELETE_TRANSFER_STOCK: 23, // xóa phiếu chuyển kho
  DELETE_IMPORT_STOCK: 24, // xoa phieu nhap kho tu nha cung cap
  DELETE_EXPORT_STOCK: 25, // xoa phieu xuat kho tra nha cung cap
  IMPORT_FROM_TRADE_IN: 26, // nhập kho thu cũ
  CANCEL_TRANSFER: 27, // hủy phiếu chuyển
  IMPORT_HOLDING: 28, // nhập kho giữ hàng
  UPDATE_IMPORT_HOLDING: 29, // cập nhật nhập kho giữ hàng
  DELETE_IMPORT_HOLDING: 30, // xóa phiếu nhập kho giữ hàng
  EXPORT_HOLDING: 31, // xuất trả giữ hàng
  DELETE_EXPORT_HOLDING: 32, // xóa phiếu xuất trả giữ hàng
  CANCEL_HOLDING: 33, // hủy phiếu giữ hàng
  DELETE_IMPORT_WARRANTY: 34, // xoa phieu nhap kho tu bao hanh
  DELETE_EXPORT_WARRANTY: 35, // xoa phieu xuat kho tra bao hanh
  DELETE_IMPORT_TRADE_IN: 36, // xoa phieu nhap kho tu bao hanh
  IMPORT_WARRANTY_FROM_BILL: 37, // nhập kho bảo hành từ hóa đơn
  EXPORT_WARRANTY_FROM_BILL: 38, // xuất kho bảo hành từ hóa đơn
  UPDATE_IMPORT_WARRANTY_FROM_BILL: 39, // cập nhật nhập kho bảo hành từ hóa đơn
  UPDATE_EXPORT_WARRANTY_FROM_BILL: 40, // cập nhật xuất kho bảo hành từ hóa đơn
  DELETE_IMPORT_WARRANTY_FROM_BILL: 41, // xóa phiếu nhập kho bảo hành từ hóa đơn
  DELETE_EXPORT_WARRANTY_FROM_BILL: 42, // xóa phiếu xuất kho bảo hành từ hóa đơn
  EXPORT_STOCK_BY_WARRANTY_BILL: 43, // xuất kho bởi đổi sp từ hóa đơn bảo hành
  DELETE_REQUIRE_EXPORT_WARRANTY_STOCK: 44, // xóa phiếu yêu cầu xuất nhập kho bảo hành
  EXPORT_WARRANTY_TO_PROVIDER: 45, // xuất kho trả nhà cung cấp
  UPDATE_EXPORT_WARRANTY_TO_PROVIDER: 46, // cập nhật xuất kho trả nhà cung cấp
  DELETE_EXPORT_WARRANTY_TO_PROVIDER: 47, // xóa xuất kho trả nhà cung cấp
  IMPORT_STOCK_BY_WARRANTY_COMPLETION: 48, // nhập kho bởi phiếu hoàn tất bảo hành
  EXPORT_STOCK_BY_WARRANTY_COMPLETION: 49, // xuất kho bởi phiếu hoàn tất bảo hành
  CREATE_WARRANTY_COMPLETION_SLIP: 50, // xuất kho bởi phiếu hoàn tất bảo hành
  DELETE_WARRANTY_COMPLETION_SLIP: 51, // xuất kho bởi phiếu hoàn tất bảo hành
  DELETE_IMPORT_STOCK_BY_WARRANTY_COMPLETION: 52, // xoá phiếu nhập kho bởi phiếu hoàn tất bảo hành
  DELETE_EXPORT_STOCK_BY_WARRANTY_COMPLETION: 53, // xoá phiếu xuất kho bởi phiếu hoàn tất bảo hành
  EXPORT_WARRANTY_STOCK_BY_DELETE_WARRANTY_BILL: 54, // xuất kho bảo hành bởi xoá hoá đơn bảo hành
  IMPORT_STOCK_BY_DELETE_WARRANTY_BILL: 55, // nhập kho bởi xoá hoá đơn bảo hành
  IMPORT_STOCK_BY_DELETE_STORE_WARRANTY_BILL: 56, // nhập kho bởi xoá hoá đơn bảo hành (lỗi do cửa hàng)
  EXPORT_STOCK_BY_CREATE_STORE_WARRANTY_BILL: 57, // xuất kho bởi tạo hoá đơn bảo hành (lỗi do cửa hàng)
  DELETE_EXPORT_STOCK_BY_CREATE_STORE_WARRANTY_BILL: 58, // nhập kho bởi xoá đơn bảo hành(do lỗi phát sinh cửa hàng)
  EXPORT_STOCK_BY_INVENTORY_CHECK: 59, // xuất kho từ phiếu kiểm kê sản phẩm
  IMPORT_STOCK_BY_INVENTORY_CHECK: 60, // nhập kho từ phiếu kiểm kê sản phẩm
  EXPORT_LENDING: 61, // xuất kho cho mượn máy
  UPDATE_EXPORT_LENDING: 62, // cập nhật phiếu xuất kho cho mượn máy
  DELETE_EXPORT_LENDING: 63, // xoá phiếu xuất kho cho mượn máy
  IMPORT_STOCK_LENDING: 64, // nhập kho nhận máy cho mượn
  IMPORT_WARRANTY_FROM_PROVIDER: 65, // nhập kho sản phẩm bảo hành từ nhà cung cấp
});

module.exports.WARRANTY_ERROR_BY = Object.freeze({
  BILL: 1, // lỗi do hoá đơn
  STORE: 2, // lỗi do cửa hàng
});

module.exports.LENDING_SLIP_STATUS = Object.freeze({
  BORROWING: 1, // Đang cho mượn
  RETURNED: 2, // Đã trả máy
});

module.exports.CUSTOMER_APPELLATION = Object.freeze({
  MR: 1, // Anh/Ông
  MS: 2, // Chị/Bà
});

module.exports.PO_SENT_STATUS = Object.freeze({
  NEW: 0,
  SENT_FAIL: 1,
  SENT_SUCCESS: 2,
});

module.exports.COUPON_SCOPE_CHANNEL = {
  BOTH: 1,
  OFFLINE: 2,
  ONLINE: 3,
};

module.exports.DISCOUNT_AMOUNT_TYPE = Object.freeze({
  MONEY: 'AMOUNT',
  PERCENT: 'PERCENT',
});

module.exports.DISCOUNT_AMOUNT = Object.freeze({
  AMOUNT: 'AMOUNT',
  PERCENT: 'PERCENT',
});

module.exports.APPROVAL_ENTITY_TYPE = Object.freeze({
  BILL: 1, // hóa đơn bán hàng
  ORDER: 2, // đơn hàng
  STOCK_SLIP: 3, // phiếu thu cũ
});

module.exports.DEALSHEET_STATUS = Object.freeze({
  ACTIVE: 1, //hoạt động
  INACTIVE: 0, //ngưng hoạt động
});
module.exports.DEALSHEET_TYPE = Object.freeze({
  HOT_SALE: 1, //hoạt động
  JBP: 2, //ngưng hoạt động
});

module.exports.TRADE_IN_STATUS = Object.freeze({
  QUOTE: 1, // đã báo giá
  COLLECTED: 2, // đã thu cũ
});

module.exports.SAMSUNG_ACTIVE_STATUS = {
  CHK_FMT_I2: 2, // ngay kich hoat khong hop le
  IMEI_ACTV: 4, // Kích hoạt thành công
  IMEI_DUPL: 5, // Máy bán ra sau khi kích hoạt trước
  IMEI_NO: 6, // IMEI chưa được kích hoạt thành công
  IMEI_NOMOD: 8, // IMEI nhập ngoài
  IMEI_OLDMD: 15, // IMEI quá hạn bảo hành
  IMEI_VALID: 10, // Mã IMEI hợp lệ
  IMEI_WRGFM: 11, // IMEI sai
  NOAUTH2: 13, // Sitecode sai
};

module.exports.SALARY_REPORT_STATUS = Object.freeze({
  NONE: 0,
  NEW: 1,
  PROCESSING: 2,
  DONE: 3,
});

module.exports.BUSINESS_STATUS = Object.freeze({
  ACTIVE: 1,
  INACTIVATE: 2,
});

module.exports.SHIPMENT_ENTITY_TYPE = Object.freeze({
  BILL: 1,
  ORDER: 2,
  STOCK_SLIP: 3,
});

module.exports.SHIPMENT_TRIP_TYPE = Object.freeze({
  FULL_ROAD: 1,
  HAFT_ROAD: 2,
  FREE_ROAD: 3,
});

module.exports.USER_ACCESS_STATUS = Object.freeze({
  ACTIVE: 1,
  DEACTIVE: 2,
});

module.exports.STOCK_SLIP_RELATION_TYPE = Object.freeze({
  INDEPENDENT: 1, // Phiếu độc lập
  PARENT: 2, // Phiếu tổng
  CHILD: 3, // Phiếu con
});

module.exports.TICKET_STATUS = Object.freeze({
  NEW: 0,
  RECORDED_INFOMATION: 1,
  PROCESSING: 2,
  COMPLETED: 3,
  REJECT: 4,
});

module.exports.TICKET_TYPE_STATUS = Object.freeze({
  OFF: 0,
  ON: 1,
});

module.exports.FUNCTION_ACTION_TICKET = Object.freeze({
  POINT_TRANSFER: 'POINT_TRANSFER',
});

module.exports.POINT_TRANSFER_STATUS = Object.freeze({
  NEW: 0,
  COMPLETED: 1,
  REJECT: 2,
});

module.exports.STATUS_CODE = Object.freeze({
  SUCCESS: 1, // thành công
  ERROR: 0, // thất bại
});

module.exports.MODULE_TYPE = Object.freeze({
  CUSTOMER: 1,
  ORDER: 2,
  BILL: 3,
  PRODUCT: 4,
  PRODUCT_IMEI: 5,
  TRADE_IN: 7,
  STOCK: 8,
  PRE_ORDER: 9,
});

module.exports.STOCK_SEARCH_TYPE = Object.freeze({
  REQUIRE_EXPORT_STOCK: 12,
});

module.exports.FUNCTION_ACTION_TICKET = Object.freeze({
  POINT_TRANSFER: 'POINT_TRANSFER',
  ADD_ORDER_FOR_BILL: 'ADD_ORDER_FOR_BILL',
  PHONE_NUMBER_CHANGE: 'PHONE_NUMBER_CHANGE',
});

module.exports.POINT_TRANSFER_STATUS = Object.freeze({
  NEW: 0,
  COMPLETED: 1,
  REJECT: 2,
});

module.exports.STATUS_CODE = Object.freeze({
  SUCCESS: 1, // thành công
  ERROR: 0, // thất bại
});

module.exports.STOCK_SLIP_RELATION_TYPE = Object.freeze({
  INDEPENDENT: 1, // Phiếu độc lập
  PARENT: 2, // Phiếu tổng
  CHILD: 3, // Phiếu con
});

module.exports.STOCK_SEARCH_TYPE = Object.freeze({
  REQUIRE_EXPORT_STOCK: 12,
  EXPORT_STOCK_LOSS: 13, //xuất kho thất thoát
  EXPORT_STOCK_CLEARANCE: 13, // xuất kho thanh lý
  IMPORT_STOCK_LOSS: 14, // nhập kho thất thoát
  IMPORT_ADJUST_STOCK_SLIP: 15, // nhập cân kho
  EXPORT_ADJUST_STOCK_SLIP: 16, // xuất cân kho
});

module.exports.STATUS_CODE = Object.freeze({
  SUCCESS: 1, // thành công
  ERROR: 0, // thất bại
});

module.exports.STORE_PO_STATUS = Object.freeze({
  NEW: 1, // mới
  APPROVED: 2, // đã duyệt
  CONFIRMED: 3, // đã xác nhận
  CANCELD: 4, // đã hủy
  REQUEST_APPROVAL: 5, // yêu cầu duyệt
  COMPLETED: 6, // Đã  hoàn thành
});

module.exports.STORE_TYPE_NAME = Object.freeze({
  STORE: 'Showroom',
  WAREHOUSE: 'Kho',
});

module.exports.PRODUCT_TYPE_VEHICLE = Object.freeze({
  CHASSIS_ENGINE: 'CHASSIS_ENGINE',
  SERIES: 'SERIES',
  DEFAULT: 'DEFAULT',
  SERVICE: 'SERVICE',
});

module.exports.STOCK_SLIP_TYPE_VEHICLE = Object.freeze({
  IMPORT_STOCK: 'IMPORT_STOCK',
  EXPORT_STOCK: 'EXPORT_STOCK',
});

module.exports.APPLY_CHANNEL = Object.freeze({
  OFFLINE: 'OFFLINE',
  ONLINE: 'ONLINE',
  BOTH: 'BOTH',
});

module.exports.EMPTY_ENGINE_NUMBER = 'xxxxxxxxxx';

module.exports.SELECT_CHASSIS_REASON = Object.freeze({
  NOT_FOUND_CHASSIS_ENGINE: 1, // Không tìm thấy số khung, số máy
  FORM_ERROR: 2, // Lỗi hình thức
  CLIENT_NOT_ACCEPT: 3, // Khách hàng không đồng ý
  CLIENT_RESERVED: 4, // Khách hàng đã đặt cọc
  OTHER: 5, // Lý do khác
});

module.exports.SELECT_CHASSIS_REASON_MAPPING = Object.freeze({
  NOT_FOUND_CHASSIS_ENGINE: 'Không tìm thấy SK/SM', // Không tìm thấy số khung, số máy
  FORM_ERROR: 'Lỗi hình thức',
  CLIENT_NOT_ACCEPT: 'Khách không đồng ý',
  CLIENT_RESERVED: 'Đã có khách đặt trước',
  OTHER: 'Khác',
});

module.exports.PRODUCT_CHASSIS_SERIES_STATUS = Object.freeze({
  NEW: 'NEW', // Mới
  SALED: 'SALED', // Đã bán
  TRANSFERING: 'TRANSFERING', // Đang vận chuyển
  ERROR: 'ERROR', // Lỗi
  RETURN_TO_SUPPLIER: 'RETURN_TO_SUPPLIER', // Đã trả NCC
  STOCK_TRANSFER: 'STOCK_TRANSFER', // Đang chuyển kho
  EXPORT_WARRANTY: 'EXPORT_WARRANTY', // đã trả bảo hành
  ON_WARRANTY: 'ON_WARRANTY', // đang bảo hành
  ON_HOLDING: 'ON_HOLDING', // đang giữ hàng
  LENDING: 'LENDING', // đang cho mượn
  LOSS: 'LOSS', // thất thoát
});

module.exports.GENDER = Object.freeze({
  MALE: 1,
  FEMALE: 2,
  OTHER: 3,
});

module.exports.CUSTOMER_GROUP = Object.freeze({
  NEW: 1,
  OLD: 2,
});

module.exports.LEAD_STATUS = Object.freeze({
  INTERESTED: 1,
  NOT_INTERESTED: 2,
  POTENTIAL: 3,
  PURCHASED: 4,
});

module.exports.LEAD_SOURCE = Object.freeze({
  EMPLOYEE_REFERRAL: 1,
  DIRECT: 2,
  CTX: 3,
  FANPAGE: 4,
  TIKTOK: 5,
  HOTLINE_CH: 6,
  CSKH_CR: 7,
  SHOP_IN_SHOP: 8,
  EMPLOYEE: 9,
  LOCAL: 10,
});

module.exports.LEAD_TITLE = Object.freeze({
  MR: 1,
  MS: 2,
  MISS: 3,
  BRO: 4,
  SIS: 5,
  OTHER: 6,
});

module.exports.LEAD_EVALUATION = Object.freeze({
  NOT_CONTACTED: 1,
  CONTACTED: 2,
  CONVERTED: 3,
});

module.exports.PRODUCT_INTEREST_STATUS = Object.freeze({
  INTERESTED: 1,
  NOT_INTERESTED: 2,
});

module.exports.CONVERTED_CUSTOMER_TYPE = Object.freeze({
  INDIVIDUAL: 1,
  BUSINESS: 2,
});

/** PERMISSION ENUM */
module.exports.PERMISSIONS = Object.freeze({
  // Accountant permissions
  ACCOUNTANT_DELETE: 'ACCOUNTANT_DELETE',
  ACCOUNTANT_INSERT: 'ACCOUNTANT_INSERT',
  ACCOUNTANT_UPDATE: 'ACCOUNTANT_UPDATE',
  ACCOUNTANT_VIEW: 'ACCOUNTANT_VIEW',

  // IMEI permissions
  ACTIVE_IMEI: 'ACTIVE_IMEI',
  ACTIVE_IMEI_BILL: 'ACTIVE_IMEI_BILL',

  // Approval permissions
  APPROVAL_APPROVE: 'APPROVAL_APPROVE',
  APPROVAL_CONFIG_DELETE: 'APPROVAL_CONFIG_DELETE',
  APPROVAL_CONFIG_INSERT: 'APPROVAL_CONFIG_INSERT',
  APPROVAL_CONFIG_UPDATE: 'APPROVAL_CONFIG_UPDATE',
  APPROVAL_CONFIG_VIEW: 'APPROVAL_CONFIG_VIEW',
  APPROVAL_DELETE: 'APPROVAL_DELETE',
  APPROVAL_INSERT: 'APPROVAL_INSERT',
  APPROVAL_PAID: 'APPROVAL_PAID',
  APPROVAL_UPDATE: 'APPROVAL_UPDATE',
  APPROVAL_VIEW: 'APPROVAL_VIEW',

  // Area permissions
  AREA_DELETE: 'AREA_DELETE',
  AREA_INSERT: 'AREA_INSERT',
  AREA_UPDATE: 'AREA_UPDATE',
  AREA_VIEW: 'AREA_VIEW',

  // Bill permissions
  BILL_DELETE: 'BILL_DELETE',
  BILL_EDIT_PRODUCT_PRICE: 'BILL_EDIT_PRODUCT_PRICE',
  BILL_EXPORT: 'BILL_EXPORT',
  BILL_INSERT: 'BILL_INSERT',
  BILL_INSERT_RETURN_UNLIMIT: 'BILL_INSERT_RETURN_UNLIMIT',
  BILL_UPDATE: 'BILL_UPDATE',
  BILL_UPDATE_UNLIMIT: 'BILL_UPDATE_UNLIMIT',
  BILL_VIEW: 'BILL_VIEW',
  BILL_VIEW_ALL: 'BILL_VIEW_ALL',
  BILL_VIEW_FULL_EXTERNAL_IMEI_NO: 'BILL_VIEW_FULL_EXTERNAL_IMEI_NO',

  // BI permissions
  BI_REVENUE_VIEW: 'BI_REVENUE_VIEW',
  BI_SALES_CAPACITY_INVENTORY_VIEW: 'BI_SALES_CAPACITY_INVENTORY_VIEW',

  // Brand permissions
  BRAND_DELETE: 'BRAND_DELETE',
  BRAND_INSERT: 'BRAND_INSERT',
  BRAND_UPDATE: 'BRAND_UPDATE',
  BRAND_VIEW: 'BRAND_VIEW',

  // Campaign permissions
  CAMPAIGN_DELETE: 'CAMPAIGN_DELETE',
  CAMPAIGN_EXCEL_EXPORT: 'CAMPAIGN_EXCEL_EXPORT',
  CAMPAIGN_INSERT: 'CAMPAIGN_INSERT',
  CAMPAIGN_UPDATE: 'CAMPAIGN_UPDATE',
  CAMPAIGN_VIEW: 'CAMPAIGN_VIEW',

  // Category approval permissions
  CATE_APPROVAL_APPROVE: 'CATE_APPROVAL_APPROVE',
  CATE_APPROVAL_DELETE: 'CATE_APPROVAL_DELETE',
  CATE_APPROVAL_INSERT_CREATE: 'CATE_APPROVAL_INSERT_CREATE',
  CATE_APPROVAL_INSERT_DELETE: 'CATE_APPROVAL_INSERT_DELETE',
  CATE_APPROVAL_INSERT_MERGE: 'CATE_APPROVAL_INSERT_MERGE',
  CATE_APPROVAL_INSERT_MOVE: 'CATE_APPROVAL_INSERT_MOVE',
  CATE_APPROVAL_INSERT_UPDATE: 'CATE_APPROVAL_INSERT_UPDATE',
  CATE_APPROVAL_VIEW: 'CATE_APPROVAL_VIEW',
  CATE_APPROVAL_VIEW_ONLY: 'CATE_APPROVAL_VIEW_ONLY',

  // Category permissions
  CATE_DELETE: 'CATE_DELETE',
  CATE_INSERT: 'CATE_INSERT',
  CATE_MERGE: 'CATE_MERGE',
  CATE_MOVE: 'CATE_MOVE',
  CATE_UPDATE: 'CATE_UPDATE',
  CATE_VIEW: 'CATE_VIEW',

  // Company permissions
  COMPANY_DELETE: 'COMPANY_DELETE',
  COMPANY_INSERT: 'COMPANY_INSERT',
  COMPANY_UPDATE: 'COMPANY_UPDATE',
  COMPANY_VIEW: 'COMPANY_VIEW',

  // Config permission
  CONFIG: 'CONFIG',

  // Coupon permissions
  COUPON_APPLY_ALL_CUSTOMER: 'COUPON_APPLY_ALL_CUSTOMER',
  COUPON_APPLY_ALL_PRODUCT: 'COUPON_APPLY_ALL_PRODUCT',
  COUPON_DELETE: 'COUPON_DELETE',
  COUPON_INSERT: 'COUPON_INSERT',
  COUPON_UPDATE: 'COUPON_UPDATE',
  COUPON_VIEW: 'COUPON_VIEW',

  // Contract permissions
  CONTRACT_VIEW: 'CONTRACT_VIEW',
  CONTRACT_APPROVE: 'CONTRACT_APPROVE',
  CONTRACT_DELETE: 'CONTRACT_DELETE',
  CONTRACT_CONFIRM: 'CONTRACT_CONFIRM',

  // Customer care permissions
  CUSTOMER_CARE_DELETE: 'CUSTOMER_CARE_DELETE',
  CUSTOMER_CARE_INSERT: 'CUSTOMER_CARE_INSERT',
  CUSTOMER_CARE_UPDATE: 'CUSTOMER_CARE_UPDATE',
  CUSTOMER_CARE_VIEW: 'CUSTOMER_CARE_VIEW',

  // Customer permissions
  CUSTOMER_BLACK_LIST_CREATE: 'CUSTOMER_BLACK_LIST_CREATE',
  CUSTOMER_BLACK_LIST_UPDATE: 'CUSTOMER_BLACK_LIST_UPDATE',
  CUSTOMER_BLACK_LIST_VIEW: 'CUSTOMER_BLACK_LIST_VIEW',
  CUSTOMER_DELETE: 'CUSTOMER_DELETE',
  CUSTOMER_EXPORT: 'CUSTOMER_EXPORT',
  CUSTOMER_INSERT: 'CUSTOMER_INSERT',
  CUSTOMER_UPDATE: 'CUSTOMER_UPDATE',
  CUSTOMER_VIEW: 'CUSTOMER_VIEW',

  // Dealsheet permissions
  DEALSHEET_DELETE: 'DEALSHEET_DELETE',
  DEALSHEET_INSERT: 'DEALSHEET_INSERT',
  DEALSHEET_UPDATE: 'DEALSHEET_UPDATE',
  DEALSHEET_VIEW: 'DEALSHEET_VIEW',

  // Debt permissions
  DEBT_CREDIT_VIEW: 'DEBT_CREDIT_VIEW',
  DEBT_INSTALLMENT_VIEW: 'DEBT_INSTALLMENT_VIEW',
  DEBT_PROVIDER_VIEW: 'DEBT_PROVIDER_VIEW',
  DEBT_STOCK_DELETE: 'DEBT_STOCK_DELETE',
  DEBT_STOCK_INSERT: 'DEBT_STOCK_INSERT',
  DEBT_STOCK_UPDATE: 'DEBT_STOCK_UPDATE',
  DEBT_STOCK_VIEW: 'DEBT_STOCK_VIEW',

  // Department permissions
  DEPARTMENT_DELETE: 'DEPARTMENT_DELETE',
  DEPARTMENT_INSERT: 'DEPARTMENT_INSERT',
  DEPARTMENT_UPDATE: 'DEPARTMENT_UPDATE',
  DEPARTMENT_VIEW: 'DEPARTMENT_VIEW',

  // Discount permissions
  DISCOUNT_DELETE: 'DISCOUNT_DELETE',
  DISCOUNT_INSERT: 'DISCOUNT_INSERT',
  DISCOUNT_UPDATE: 'DISCOUNT_UPDATE',
  DISCOUNT_VIEW: 'DISCOUNT_VIEW',

  // Employee permissions
  EMPLOYEE_DELETE: 'EMPLOYEE_DELETE',
  EMPLOYEE_INSERT: 'EMPLOYEE_INSERT',
  EMPLOYEE_UPDATE: 'EMPLOYEE_UPDATE',
  EMPLOYEE_VIEW: 'EMPLOYEE_VIEW',

  // Export permissions
  EXPORT_WITHIN_30DAY: 'EXPORT_WITHIN_30DAY',
  EXPORT_WITHIN_60DAY: 'EXPORT_WITHIN_60DAY',
  EXPORT_WITHIN_90DAY: 'EXPORT_WITHIN_90DAY',

  // Feature flag permissions
  FEATURE_FLAG_CREATE: 'FEATURE_FLAG_CREATE',
  FEATURE_FLAG_DELETE: 'FEATURE_FLAG_DELETE',
  FEATURE_FLAG_UPDATE: 'FEATURE_FLAG_UPDATE',
  FEATURE_FLAG_VIEW: 'FEATURE_FLAG_VIEW',

  // IMEI permissions
  IMEI_ACTIVE_REPORT_VIEW: 'IMEI_ACTIVE_REPORT_VIEW',
  IMEI_HISTORY_VIEW: 'IMEI_HISTORY_VIEW',

  // Installment permissions
  INSTALLMENT_DELETE: 'INSTALLMENT_DELETE',
  INSTALLMENT_INSERT: 'INSTALLMENT_INSERT',
  INSTALLMENT_UPDATE: 'INSTALLMENT_UPDATE',
  INSTALLMENT_VIEW: 'INSTALLMENT_VIEW',

  // Inventory permissions
  INVENTORY_BALANCE: 'INVENTORY_BALANCE',

  // MKO permissions
  MKO_GET_PRODUCTS: 'MKO_GET_PRODUCTS',
  MKO_GET_TRANSACTIONS: 'MKO_GET_TRANSACTIONS',

  // Order permissions
  ORDER_DELETE: 'ORDER_DELETE',
  ORDER_EXPORT: 'ORDER_EXPORT',
  ORDER_INSERT: 'ORDER_INSERT',
  ORDER_SOURCE_DELETE: 'ORDER_SOURCE_DELETE',
  ORDER_SOURCE_INSERT: 'ORDER_SOURCE_INSERT',
  ORDER_SOURCE_UPDATE: 'ORDER_SOURCE_UPDATE',
  ORDER_SOURCE_VIEW: 'ORDER_SOURCE_VIEW',
  ORDER_UPDATE: 'ORDER_UPDATE',
  ORDER_UPDATE_ACCOUNTANT: 'ORDER_UPDATE_ACCOUNTANT',
  ORDER_VIEW: 'ORDER_VIEW',

  // PO permissions
  PO_ACCOUNT_APPROVE: 'PO_ACCOUNT_APPROVE',
  PO_CANCEL: 'PO_CANCEL',
  PO_DELETE: 'PO_DELETE',
  PO_IMPORT_STOCK: 'PO_IMPORT_STOCK',
  PO_INSERT: 'PO_INSERT',
  PO_UPDATE: 'PO_UPDATE',
  PO_VIEW: 'PO_VIEW',
  PO_VIEW_ALL: 'PO_VIEW_ALL',

  // Point permissions
  POINT_DELETE: 'POINT_DELETE',
  POINT_INSERT: 'POINT_INSERT',
  POINT_TRANSFER_VIEW: 'POINT_TRANSFER_VIEW',
  POINT_TRANSFER_VIEW_ALL: 'POINT_TRANSFER_VIEW_ALL',
  POINT_UPDATE: 'POINT_UPDATE',
  POINT_VIEW: 'POINT_VIEW',

  // Portal Fast Require Stock permissions
  PORTAL_FAST_REQUIRE_STOCK_ISSUE: 'PORTAL_FAST_REQUIRE_STOCK_ISSUE',
  PORTAL_FAST_REQUIRE_STOCK_VIEW_TOOLBAR:
    'PORTAL_FAST_REQUIRE_STOCK_VIEW_TOOLBAR',

  // POSM permissions
  POSM_FORM_DELETE: 'POSM_FORM_DELETE',
  POSM_FORM_EXCEL_IMPORT: 'POSM_FORM_EXCEL_IMPORT',
  POSM_FORM_INSERT: 'POSM_FORM_INSERT',
  POSM_FORM_SUBMISSION_VIEW: 'POSM_FORM_SUBMISSION_VIEW',
  POSM_FORM_UPDATE: 'POSM_FORM_UPDATE',
  POSM_FORM_VIEW: 'POSM_FORM_VIEW',
  POSM_REPORT_INSERT: 'POSM_REPORT_INSERT',

  // Pre-order permissions
  PRE_ORDER_FORM_CREATE: 'PRE_ORDER_FORM_CREATE',
  PRE_ORDER_FORM_UPDATE: 'PRE_ORDER_FORM_UPDATE',

  // Priority cart permissions
  PRIORITY_CART_DELETE: 'PRIORITY_CART_DELETE',
  PRIORITY_CART_INSERT: 'PRIORITY_CART_INSERT',
  PRIORITY_CART_UPDATE: 'PRIORITY_CART_UPDATE',
  PRIORITY_CART_VIEW: 'PRIORITY_CART_VIEW',

  // Product attach permissions
  PRODUCT_ATTACH_DELETE: 'PRODUCT_ATTACH_DELETE',
  PRODUCT_ATTACH_INSERT: 'PRODUCT_ATTACH_INSERT',
  PRODUCT_ATTACH_UPDATE: 'PRODUCT_ATTACH_UPDATE',
  PRODUCT_ATTACH_VIEW: 'PRODUCT_ATTACH_VIEW',

  // Product permissions
  PRODUCT_CODE_UPDATE: 'PRODUCT_CODE_UPDATE',
  PRODUCT_DELETE: 'PRODUCT_DELETE',
  PRODUCT_EXPORT: 'PRODUCT_EXPORT',
  PRODUCT_INSERT: 'PRODUCT_INSERT',
  PRODUCT_ORIGINAL_PRICE_VIEW: 'PRODUCT_ORIGINAL_PRICE_VIEW',
  PRODUCT_SYNC: 'PRODUCT_SYNC',
  PRODUCT_UPDATE: 'PRODUCT_UPDATE',
  PRODUCT_UPDATE_PRICE: 'PRODUCT_UPDATE_PRICE',
  PRODUCT_VAT_UPSERT: 'PRODUCT_VAT_UPSERT',
  PRODUCT_VIE_ON_VIEW: 'PRODUCT_VIE_ON_VIEW',
  PRODUCT_VIEW: 'PRODUCT_VIEW',

  // Product price permissions
  PRODUCT_PRICE_DELETE: 'PRODUCT_PRICE_DELETE',
  PRODUCT_PRICE_INSERT: 'PRODUCT_PRICE_INSERT',
  PRODUCT_PRICE_UPDATE: 'PRODUCT_PRICE_UPDATE',
  PRODUCT_PRICE_VIEW: 'PRODUCT_PRICE_VIEW',

  // Product promotion permissions
  PRODUCT_PROMOTION_DELETE: 'PRODUCT_PROMOTION_DELETE',
  PRODUCT_PROMOTION_INSERT: 'PRODUCT_PROMOTION_INSERT',
  PRODUCT_PROMOTION_UPDATE: 'PRODUCT_PROMOTION_UPDATE',
  PRODUCT_PROMOTION_VIEW: 'PRODUCT_PROMOTION_VIEW',

  // Provider permissions
  PROVIDER_DELETE: 'PROVIDER_DELETE',
  PROVIDER_INSERT: 'PROVIDER_INSERT',
  PROVIDER_UPDATE: 'PROVIDER_UPDATE',
  PROVIDER_VIEW: 'PROVIDER_VIEW',

  // Purchasing department permissions
  PURCHASING_DEPARTMENT_CREATE: 'PURCHASING_DEPARTMENT_CREATE',
  PURCHASING_DEPARTMENT_DELETE: 'PURCHASING_DEPARTMENT_DELETE',
  PURCHASING_DEPARTMENT_VIEW: 'PURCHASING_DEPARTMENT_VIEW',

  // Region permissions
  REGION_DELETE: 'REGION_DELETE',
  REGION_INSERT: 'REGION_INSERT',
  REGION_UPDATE: 'REGION_UPDATE',
  REGION_VIEW: 'REGION_VIEW',

  // Report permissions
  REPORT_HISTORY_VIEW: 'REPORT_HISTORY_VIEW',
  REPORT_VIEW: 'REPORT_VIEW',

  // Reward permissions
  REWARD_DELETE: 'REWARD_DELETE',
  REWARD_INSERT: 'REWARD_INSERT',
  // Reward permissions (continued)
  REWARD_UPDATE: 'REWARD_UPDATE',
  REWARD_VIEW: 'REWARD_VIEW',

  // Role permissions
  ROLE_DELETE: 'ROLE_DELETE',
  ROLE_INSERT: 'ROLE_INSERT',
  ROLE_UPDATE: 'ROLE_UPDATE',
  ROLE_VIEW: 'ROLE_VIEW',

  // RR permissions
  RR_VIEW_ALL: 'RR_VIEW_ALL',
  RR_VIEW_BILL: 'RR_VIEW_BILL',
  RR_VIEW_BY_EMP: 'RR_VIEW_BY_EMP',

  // Salary permissions
  SALARY_REPORT: 'SALARY_REPORT',

  // Shift work permissions
  SHIFTWORK_CONFIG_DELETE: 'SHIFTWORK_CONFIG_DELETE',
  SHIFTWORK_CONFIG_INSERT: 'SHIFTWORK_CONFIG_INSERT',
  SHIFTWORK_CONFIG_UPDATE: 'SHIFTWORK_CONFIG_UPDATE',
  SHIFTWORK_CONFIG_VIEW: 'SHIFTWORK_CONFIG_VIEW',
  SHIFTWORK_DELETE: 'SHIFTWORK_DELETE',
  SHIFTWORK_INSERT: 'SHIFTWORK_INSERT',
  SHIFTWORK_UPDATE: 'SHIFTWORK_UPDATE',
  SHIFTWORK_VIEW: 'SHIFTWORK_VIEW',

  // Shipment permissions
  SHIPMENT_DELETE: 'SHIPMENT_DELETE',
  SHIPMENT_EXPORT: 'SHIPMENT_EXPORT',
  SHIPMENT_INSERT: 'SHIPMENT_INSERT',
  SHIPMENT_UPDATE: 'SHIPMENT_UPDATE',
  SHIPMENT_VIEW: 'SHIPMENT_VIEW',

  // Stock permissions
  STOCK_ADJUST: 'STOCK_ADJUST',
  STOCK_APPROVE_TRANSFER: 'STOCK_APPROVE_TRANSFER',
  STOCK_CANCEL_TRANSFER: 'STOCK_CANCEL_TRANSFER',
  STOCK_CHECK_CONFIRM: 'STOCK_CHECK_CONFIRM',
  STOCK_CHECK_DELETE: 'STOCK_CHECK_DELETE',
  STOCK_CHECK_INSERT: 'STOCK_CHECK_INSERT',
  STOCK_CHECK_UPDATE: 'STOCK_CHECK_UPDATE',
  STOCK_CHECK_VIEW: 'STOCK_CHECK_VIEW',
  STOCK_DELETE: 'STOCK_DELETE',
  STOCK_DELETE_TRANSFER: 'STOCK_DELETE_TRANSFER',
  STOCK_EXPORT: 'STOCK_EXPORT',
  STOCK_EXPORT_DELETE: 'STOCK_EXPORT_DELETE',
  STOCK_EXPORT_INSERT: 'STOCK_EXPORT_INSERT',
  STOCK_EXPORT_UPDATE: 'STOCK_EXPORT_UPDATE',
  STOCK_EXPORT_VIEW: 'STOCK_EXPORT_VIEW',
  STOCK_IMPORT_DELETE: 'STOCK_IMPORT_DELETE',
  STOCK_IMPORT_INSERT: 'STOCK_IMPORT_INSERT',
  STOCK_IMPORT_UPDATE: 'STOCK_IMPORT_UPDATE',
  STOCK_IMPORT_VIEW: 'STOCK_IMPORT_VIEW',
  STOCK_INSERT: 'STOCK_INSERT',
  STOCK_SEARCH_PRODUCT: 'STOCK_SEARCH_PRODUCT',
  STOCK_UPDATE: 'STOCK_UPDATE',
  STOCK_VIEW: 'STOCK_VIEW',

  // Store permissions
  STORE_DELETE: 'STORE_DELETE',
  STORE_INSERT: 'STORE_INSERT',
  STORE_PO_APPROVE: 'STORE_PO_APPROVE',
  STORE_PO_CANCEL: 'STORE_PO_CANCEL',
  STORE_PO_CONFIRM: 'STORE_PO_CONFIRM',
  STORE_PO_CREATE: 'STORE_PO_CREATE',
  STORE_PO_DELETE: 'STORE_PO_DELETE',
  STORE_PO_VIEW: 'STORE_PO_VIEW',
  STORE_PO_VIEW_ALL: 'STORE_PO_VIEW_ALL',
  STORE_UPDATE: 'STORE_UPDATE',
  STORE_VIEW: 'STORE_VIEW',
  STORE_VIEW_ALL: 'STORE_VIEW_ALL',

  // Ticket permissions
  TICKET_SETTING: 'TICKET_SETTING',
  TICKET_VIEW_ALL: 'TICKET_VIEW_ALL',

  // Trade-in permissions
  TRADE_IN_DELETE: 'TRADE_IN_DELETE',
  TRADE_IN_EXPORT: 'TRADE_IN_EXPORT',
  TRADE_IN_IMPORT_PRODUCTS_EXCEL: 'TRADE_IN_IMPORT_PRODUCTS_EXCEL',
  TRADE_IN_INSERT: 'TRADE_IN_INSERT',
  TRADE_IN_SHOW_ALL_STORE: 'TRADE_IN_SHOW_ALL_STORE',
  TRADE_IN_UPDATE: 'TRADE_IN_UPDATE',
  TRADE_IN_VIEW: 'TRADE_IN_VIEW',

  // Trade-in program permissions
  PROGRAM_TRADE_IN_DELETE: 'PROGRAM_TRADE_IN_DELETE',
  PROGRAM_TRADE_IN_INSERT: 'PROGRAM_TRADE_IN_INSERT',
  PROGRAM_TRADE_IN_UPDATE: 'PROGRAM_TRADE_IN_UPDATE',
  PROGRAM_TRADE_IN_VIEW: 'PROGRAM_TRADE_IN_VIEW',

  // Transaction permissions
  TRANSACTION_DELETE: 'TRANSACTION_DELETE',
  TRANSACTION_IMPORT_EXCEL: 'TRANSACTION_IMPORT_EXCEL',
  TRANSACTION_INSERT: 'TRANSACTION_INSERT',
  TRANSACTION_PAY_PREV_DAY: 'TRANSACTION_PAY_PREV_DAY',
  TRANSACTION_UPDATE: 'TRANSACTION_UPDATE',
  TRANSACTION_VIEW: 'TRANSACTION_VIEW',

  // Transaction category permissions
  TRANS_CATE_DELETE: 'TRANS_CATE_DELETE',
  TRANS_CATE_INSERT: 'TRANS_CATE_INSERT',
  TRANS_CATE_UPDATE: 'TRANS_CATE_UPDATE',
  TRANS_CATE_VIEW: 'TRANS_CATE_VIEW',

  // Transfer store permissions
  TRANSFER_STORE_DELETE: 'TRANSFER_STORE_DELETE',
  TRANSFER_STORE_INSERT: 'TRANSFER_STORE_INSERT',
  TRANSFER_STORE_UPDATE: 'TRANSFER_STORE_UPDATE',
  TRANSFER_STORE_VIEW: 'TRANSFER_STORE_VIEW',

  // User permissions
  USER_ACCESS_DELETE: 'USER_ACCESS_DELETE',
  USER_ACCESS_INSERT: 'USER_ACCESS_INSERT',
  USER_ACCESS_UPDATE: 'USER_ACCESS_UPDATE',
  USER_ACCESS_VIEW: 'USER_ACCESS_VIEW',
  USER_DELETE: 'USER_DELETE',
  USER_INSERT: 'USER_INSERT',
  USER_UPDATE: 'USER_UPDATE',
  USER_VIEW: 'USER_VIEW',

  // VAT invoice permissions
  VAT_INVOICE_DELETE: 'VAT_INVOICE_DELETE',
  VAT_INVOICE_EXPORT_MIFI: 'VAT_INVOICE_EXPORT_MIFI',
  VAT_INVOICE_EXPORT_MIFI_EXCEED_EXPIRED:
    'VAT_INVOICE_EXPORT_MIFI_EXCEED_EXPIRED',
  VAT_INVOICE_INSERT: 'VAT_INVOICE_INSERT',
  VAT_INVOICE_UPDATE: 'VAT_INVOICE_UPDATE',
  VAT_INVOICE_VIEW: 'VAT_INVOICE_VIEW',

  // Virtual stock permissions
  VIRTUAL_STOCK_DELETE: 'VIRTUAL_STOCK_DELETE',
  VIRTUAL_STOCK_INSERT: 'VIRTUAL_STOCK_INSERT',
  VIRTUAL_STOCK_UPDATE: 'VIRTUAL_STOCK_UPDATE',
  VIRTUAL_STOCK_VIEW: 'VIRTUAL_STOCK_VIEW',

  // Warranty permissions
  WARRANTY_DELETE: 'WARRANTY_DELETE',
  WARRANTY_INSERT: 'WARRANTY_INSERT',
  WARRANTY_REASON_CONFIG_CREATE: 'WARRANTY_REASON_CONFIG_CREATE',
  WARRANTY_REASON_CONFIG_DELETE: 'WARRANTY_REASON_CONFIG_DELETE',
  WARRANTY_REASON_CONFIG_UPDATE: 'WARRANTY_REASON_CONFIG_UPDATE',
  WARRANTY_REASON_CONFIG_VIEW: 'WARRANTY_REASON_CONFIG_VIEW',
  WARRANTY_UPDATE: 'WARRANTY_UPDATE',
  WARRANTY_VIEW: 'WARRANTY_VIEW',

  // Lead permissions
  LEAD_VIEW_ALL: 'LEAD_VIEW_ALL',
  LEAD_VIEW_ONLY: 'LEAD_VIEW_ONLY',
  LEAD_INSERT: 'LEAD_INSERT',
  LEAD_UPDATE: 'LEAD_UPDATE',
  LEAD_DELETE: 'LEAD_DELETE',
  LEAD_ASSIGN: 'LEAD_ASSIGN',
  LEAD_IMPORT: 'LEAD_IMPORT',
  LEAD_EXPORT: 'LEAD_EXPORT',
});

/** MODE VIEWING */
module.exports.MODE = Object.freeze({
  ADD: 'add',
  EDIT: 'edit',
  VIEW: 'view',
});

/** PRODUCT STATUS VAT */
module.exports.PRODUCT_STATUS_VAT = Object.freeze({
  HAS_NAME: 'ne',
  NO_NAME: 'eq',
});
